<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="header">
      <div class="title-color">
        <h1 class="title">Administrar permisos para:</h1>
        <p class="title-list">{{ profile?.username }} {{ profile?.first_name }} {{ profile?.last_name }}</p>
      </div>
    </div>
    <br />
    <div class="duallist-ui">
      <dual-list
        display="name"
        key="id"
        [source]="permisions"
        [(destination)]="selected"
        height="250px"
        [format]="format"
        [filter]="true"
      >
      </dual-list
      ><br />
      <button class="primary-button" (click)="saveChanges()">
        <span class="button-content"><mat-icon>save</mat-icon>Guardar</span>
      </button>
      <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
        <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
      </button>
    </div>
  </div>
</div>
